import Model, { belongsTo, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  TotalRevenueSegmentationBreakdownItem,
  TotalRevenueSegmentationBreakdownSummaryItem,
} from 'lumen/models';

export default class TotalRevenueSegmentationBreakdowns extends Model {
  [Type] = 'total-revenue/segmentation-breakdowns' as const;

  @belongsTo('total-revenue/segmentation-breakdown/summary-item', {
    async: false,
    inverse: null,
  })
  declare summary: TotalRevenueSegmentationBreakdownSummaryItem;

  @hasMany('total-revenue/segmentation-breakdown/item', {
    async: false,
    inverse: null,
  })
  declare segment: HasMany<TotalRevenueSegmentationBreakdownItem>;
}
